import { useAsyncFn } from 'react-use';

import { type BookingWindow } from '@service-initiation/shared-clients-tech-care-services';
import {
  ErrorType,
  getRemoteTechEligibilityAndOptions,
} from '@service-initiation/tech-care-data-access-tech-care-services';

import { remoteTechAtom, selectedRepairsAsyncAtom } from '../atoms';
import { store } from '../store';

const DEVICE_ELIGIBILITY_ERROR =
  'No operators currently have parts available to service this request';

export const useGetRemoteTechEligibility = () => {
  const remoteTech = store.get(remoteTechAtom);
  return useAsyncFn(async () => {
    let availableWindows: BookingWindow[] = [];
    let storeNumber = '';
    const selectedRepairs = await store.get(selectedRepairsAsyncAtom);

    if (selectedRepairs && selectedRepairs.length > 0) {
      const eligibilityPayload = {
        deviceRepairId: selectedRepairs[0].id,
        postal_code: remoteTech?.meetingAddress?.zip || '',
      };
      const eligibility = await getRemoteTechEligibilityAndOptions(
        eligibilityPayload
      );
      if (!eligibility.isEligible || !eligibility.options?.available_windows) {
        if (eligibility.eligibilityReason === DEVICE_ELIGIBILITY_ERROR) {
          throw new Error(ErrorType.RemoteTechDeviceIneligible);
        } else {
          throw new Error(ErrorType.RemoteTechLocationIneligible);
        }
      }
      eligibility.options?.available_windows &&
        (availableWindows = eligibility.options.available_windows);
      eligibility.options?.store?.phone &&
        (storeNumber = eligibility.options.store.phone);
    }
    store.set(remoteTechAtom, {
      ...remoteTech,
      availableWindows,
      storeInfo: { phone: storeNumber },
    });
    return {
      ...remoteTech,
      availableWindows,
      storeInfo: { phone: storeNumber },
    };
  }, [remoteTech]);
};
